// src/app/services/script-loader.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {
  private loadedScripts: Set<string> = new Set();

  loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.loadedScripts.has(src)) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.async = false;
      script.defer = false;

      script.onload = () => {
        this.loadedScripts.add(src);
        resolve();
      };

      script.onerror = (error) => reject(`Script load error: ${src}`);

      document.body.appendChild(script);
    });
  }
}
